const map = {
	"./BuddhaAkshay/loader.json": [
		11004,
		[
			4
		]
	],
	"./JanBhavishya/loader.json": [
		20347,
		[
			347
		]
	],
	"./Suvarna/loader.json": [
		83495,
		[
			495
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8173;
module.exports = webpackAsyncContext;